import { Box, Paper, Tabs, Tab, Stack } from "@mui/material";
import { Content } from "@/types";
import { MenuSection } from "@/types/menus";
import FirstSteps from "./FirstSteps";
import SectionSettingsForm from "./SectionSettingsForm";

interface Props {
  structure: MenuSection[];
  allContent: Content[];
  onAddSection?: () => void;
  activeTab: "steps" | "options";
  onTabChange: (tab: "steps" | "options") => void;
  selectedSection: MenuSection | null;
  onUpdateSection: (patch: Partial<MenuSection>) => void;
}

const TabsColumn = ({
  structure = [],
  onAddSection,
  activeTab,
  onTabChange,
  selectedSection,
  onUpdateSection,
}: Props) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        display: { xs: "none", md: "flex" },
        flexDirection: "column",
        height: "100%",
        borderRadius: 2,
        overflow: "hidden",
      }}
    >
      <Stack
        sx={{ height: 73 }}
        justifyContent="flex-end"
      >
        {/* Header Tabs */}
        <Tabs
          value={activeTab}
          onChange={(_, val) => onTabChange(val)}
          variant="fullWidth"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="Primeros pasos" value="steps" />
          <Tab label="Personalización" value="options" />
        </Tabs>
      </Stack>
      {/* Screen Content - Switch between Steps and Options Settings */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          bgcolor: "background.default",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {activeTab === "steps" ? (
          <FirstSteps
            structure={structure}
            onAddSection={onAddSection}
          />
        ) : (
          <SectionSettingsForm
            section={selectedSection}
            onUpdateSection={onUpdateSection}
          />
        )}
      </Box>
    </Paper>
  );
};

export default TabsColumn;
